import routeReplaceSelf from '@/utils/routeReplaceSelf';

const storeTemperature = {
    path: 'storeTemperature',
    name: 'storeTemperature',
    component: () => import('@/layout'),
    redirect: 'noRedirect',
    meta: {
        code: 'temperatureCheck',
        icon: 'HSIconfont hs-icon-tem',
        showRealm: ['NORMAL']
    },
    children: [
        {
            path: 'storeEslTemperature',
            name: 'storeEslTemperature',
            component: () => import('@/views/storeEslTemperature'),
            meta: { code: 'temperatureCheck:temperature' }
        },
        {
            path: 'storeShelfManage',
            name: 'storeShelfManage',
            component: routeReplaceSelf(() => import('@/views/storeShelfManage')),
            meta: { code: 'temperatureCheck:shelf' },
            children: [
                {
                    path: 'storeShelfChart',
                    name: 'storeShelfChart',
                    hidden: true,
                    component: () => import('@/views/storeShelfManage/components/ShelfChart.vue'),
                    meta: {
                        code: 'temperatureCheck_shelf_temperatureHistory',
                        activeMenu: 'storeShelfManage',
                    },
                },
            ]
        },
    ]
};

export default storeTemperature;
